<div class="error" *ngIf="alertaPerfis" style="margin-top: 10px">
  <p>
    <b>Atenção:</b> No momento, a nova versão do SISPG está disponível apenas para os usuários habilitados com o perfil
    discente.<br />Para os demais perfis, utilize a versão antiga do
    <b><a href="https://sistemas.unesp.br/posgraduacao/common.perfil.action" target="_blank">SISPG</a></b>
  </p>
</div>
<div class="custom-table">
  <hr />
  <mat-card appearance="outlined" class="info" *ngIf="perfis.length > 1">
    <p>Escolha com qual <b>Perfil</b> deseja acessar:</p>
  </mat-card>
  <table>
    <tr *ngFor="let perfil of perfis$ | async; index as i" (click)="changeSelecao(perfil)" style="cursor: pointer">
      <td
        style="font-weight: bold; display: flex"
        [ngStyle]="{ border: perfil.selecionado ? '2px solid #2196f3' : '0' }">
        <button mat-icon-button color="primary" (click)="changeSelecao(perfil)">
          <mat-icon>{{ perfil.selecionado ? 'task_alt' : 'radio_button_unchecked' }}</mat-icon>
        </button>
        <div style="line-height: 48px">
          {{ perfil.nome | perfil }}
        </div>
      </td>
    </tr>
  </table>
</div>
<app-registro-academico-selecionar></app-registro-academico-selecionar>
